// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
export const getUserInfo = () => ({
    isAuthorized: false,
    name:         '',
    userRole:     '',
});

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser:          getUserInfo(),
    tutorialOverlayIsShown: false,
};

export default state;
